import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { actions } from 'react-redux-form';
import PageTitle from '../common/page-title';
import InlineCKEditor from '../common/editor/inline-editor';
import MyStoreDetails from './store-details';
import { getOutlet } from '../../actions/outlet';
import { loadPageContent } from '../../actions/content';

class StoreDetails extends Component {
  constructor(props) {
    super(props);

    this.pageSlug = 'store-details';
  }

  componentWillMount() {
    const { match, dispatch } = this.props;

    dispatch(getOutlet(match.params.id));
    dispatch(actions.reset('deep.staff_member'));
    dispatch({ type: 'CLEAR_EDIT_STAFF_MEMBER' });
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  handleContentSaved = () => {
    const { dispatch } = this.props;
    
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    const { match, contents } = this.props;

    return (
      <Grid bsClass="container" className="details">
        <Row>
          <Col lg={12}>
            <PageTitle>Store Details</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor
              identifier={`${this.pageSlug}_content_text`}
              onContentSaved={this.handleContentSaved}
              contents={contents[`${this.pageSlug}_content_text`]}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
        <MyStoreDetails storeId={match.params.id} />
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contents: state.content.list
  };
};

export default connect(mapStateToProps)(StoreDetails);



// WEBPACK FOOTER //
// ./src/components/store-details/index.jsx